import { Text, TextProps } from '@chakra-ui/react'
import React from 'react'

export type ParagraphProps = {} & TextProps

export const Paragraph: React.FC<ParagraphProps> = props => {
  return <Text fontFamily={'longform'} {...props} />
}
